/*
  KidzCraft product gallery controller.

  Three responsibilities, all built so they degrade gracefully:
   1. Per-variant photo filtering. Every photo is always present in the HTML; this only
      toggles a CSS class. If this script fails, the shop simply shows every photo.
   2. Prev/next arrows overlaid on the main photo (they replay a thumbnail click, so they
      reuse Shopify's own logic instead of duplicating it).
   3. Click-and-drag on desktop: swipe the big photo, pan the thumbnail strip.

  Nothing here adds or removes DOM nodes, which is what keeps the gallery working after a
  variant change (Shopify re-renders the photo list over AJAX).
*/
(function () {
  if (window.__kcGalleryInit) return;
  window.__kcGalleryInit = true;

  var HIDE = 'kc-hidden';
  var applying = false;

  function currentVariantId(scope) {
    var holder = scope.querySelector('variant-selects [data-selected-variant]');
    if (holder) {
      try {
        var parsed = JSON.parse(holder.textContent);
        if (parsed && parsed.id) return String(parsed.id);
      } catch (e) {}
    }
    var param = new URLSearchParams(window.location.search).get('variant');
    return param ? String(param) : null;
  }

  function visibleThumbs(gallery) {
    var wrap = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!wrap) return [];
    return Array.prototype.filter.call(wrap.querySelectorAll('.thumbnail-list__item'), function (li) {
      return !li.classList.contains(HIDE);
    });
  }

  function applyVariantFilter(gallery) {
    if (applying) return;
    applying = true;
    try {
      var scope = gallery.closest('product-info') || document;
      var vid = currentVariantId(scope);
      var firstVisibleTarget = null;

      gallery.querySelectorAll('[data-kc-variants]').forEach(function (li) {
        var raw = li.getAttribute('data-kc-variants');
        var allowed = raw ? raw.split(',').filter(Boolean) : [];
        var show = allowed.length === 0 || !vid || allowed.indexOf(vid) !== -1;
        li.classList.toggle(HIDE, !show);
        if (show && !firstVisibleTarget && li.dataset.target) firstVisibleTarget = li.dataset.target;
      });

      // If the photo on screen isn't available for this variant, fall back to the first one that is.
      var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      var active = viewer && viewer.querySelector('.product__media-item.is-active');
      if (active && active.classList.contains(HIDE) && firstVisibleTarget && gallery.setActiveMedia) {
        gallery.setActiveMedia(firstVisibleTarget, true);
      }
    } finally {
      setTimeout(function () {
        applying = false;
      }, 60);
    }
  }

  function stepMedia(gallery, direction) {
    var items = visibleThumbs(gallery);
    if (items.length < 2) return;
    var activeIndex = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].querySelector('button[aria-current="true"]')) {
        activeIndex = i;
        break;
      }
    }
    var from = activeIndex === -1 ? 0 : activeIndex;
    var next = (from + direction + items.length) % items.length;
    var button = items[next].querySelector('button');
    if (button) button.click();
  }

  // Shopify's generic slider disables these arrows based on scroll position, which is
  // meaningless for a stacked photo list. Our own logic decides what to show, so keep
  // them clickable (a disabled <button> swallows clicks entirely).
  function keepEnabled(button) {
    if (!button) return;
    button.removeAttribute('disabled');
    new MutationObserver(function () {
      if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
    }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
  }

  function suppressNextClick(el) {
    el.addEventListener(
      'click',
      function (event) {
        event.stopPropagation();
        event.preventDefault();
      },
      { capture: true, once: true }
    );
  }

  // Thumbnail strip: real horizontal overflow, so dragging pans it.
  function enableDragScroll(el) {
    if (!el || el.dataset.kcDrag) return;
    el.dataset.kcDrag = 'true';
    var down = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      try {
        el.setPointerCapture(e.pointerId);
      } catch (err) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 5) moved = true;
      el.scrollLeft = startScroll - delta;
    });
    function end() {
      if (!down) return;
      down = false;
      if (moved) suppressNextClick(el);
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointerleave', end);
    el.addEventListener('pointercancel', end);
  }

  // Main photo: slides are stacked rather than scrolled, so a drag acts as a swipe.
  function enableDragSwipe(gallery, el) {
    if (!el || el.dataset.kcDrag) return;
    el.dataset.kcDrag = 'true';
    var down = false;
    var startX = 0;
    var moved = false;

    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true;
      moved = false;
      startX = e.clientX;
      try {
        el.setPointerCapture(e.pointerId);
      } catch (err) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - startX) > 5) moved = true;
    });
    el.addEventListener('pointerup', function (e) {
      if (!down) return;
      down = false;
      if (!moved) return;
      suppressNextClick(el);
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 40) stepMedia(gallery, delta < 0 ? 1 : -1);
    });
    el.addEventListener('pointerleave', function () {
      down = false;
    });
    el.addEventListener('pointercancel', function () {
      down = false;
    });
  }

  function wire(gallery) {
    if (gallery.dataset.kcWired) {
      applyVariantFilter(gallery);
      return;
    }
    gallery.dataset.kcWired = 'true';

    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (viewer) {
      var prev = viewer.querySelector('.slider-buttons .slider-button--prev');
      var next = viewer.querySelector('.slider-buttons .slider-button--next');
      keepEnabled(prev);
      keepEnabled(next);
      if (prev)
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          stepMedia(gallery, -1);
        });
      if (next)
        next.addEventListener('click', function (e) {
          e.preventDefault();
          stepMedia(gallery, 1);
        });
    }

    enableDragSwipe(gallery, gallery.querySelector('[id^="Slider-Gallery-"]'));
    enableDragScroll(gallery.querySelector('[id^="Slider-Thumbnails-"]'));

    // Shopify rewrites the main photo list when the variant changes; re-filter afterwards.
    var mainList = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (mainList) {
      new MutationObserver(function () {
        applyVariantFilter(gallery);
      }).observe(mainList, { childList: true });
    }

    applyVariantFilter(gallery);
  }

  function refreshAll() {
    document.querySelectorAll('media-gallery').forEach(wire);
  }

  function init() {
    refreshAll();

    // Re-filter on every variant change, whichever way it is signalled.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(refreshAll, 0);
        });
      } catch (e) {}
    }
    document.addEventListener('change', function (event) {
      if (!event.target.closest('variant-selects')) return;
      setTimeout(refreshAll, 350);
      setTimeout(refreshAll, 900);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
